module.exports = "/images/lu.svg?7904f61fb45587cbf4c46ef426f88b4b";